import React, { useContext } from 'react'
import {
  BsFillCheckSquareFill,
  BsFillSquareFill,
  BsFillQuestionSquareFill,
} from 'react-icons/bs'
import styled from 'styled-components'
import { InfoTooltipLink, Tooltip } from 'components'
import { I18nContext } from 'i18n'

const tooltips = {
  true: 'yes',
  false: 'no'
}

const MultiStateCheckbox = ({ text, value, onChange, disabled, tooltipText, name, ...rest }) => {
  const { translate } = useContext(I18nContext)
  const states = [
    { value: true, icon: <BsFillCheckSquareFill className="green" /> },
    { value: false, icon: <BsFillSquareFill className="white" /> },
    { value: null, icon: <BsFillQuestionSquareFill className="red" /> },
  ]

  const renderIcon = (state) => {
    const selectedState = states.find(({ value }) => value === state)
    return <span>{selectedState.icon}</span>
  }

  const handleOnChange = () => {
    if (disabled) return;
    const ix = states.findIndex(({ value: val }) => value === val)
    //Go for the next
    const nextIx = ix + 1 < states.length ? ix + 1 : 0
    onChange && onChange(states[nextIx].value)
  }

  const tooltip = tooltips[value] || 'unknown'

  return (
    <Container onClick={handleOnChange} {...rest}>
      <div className="d-flex">
        <Tooltip
          text={translate(`multi_check_${tooltip}`, {
            text: tooltipText || text.toLowerCase(),
          })}
        >
          {renderIcon(value)}
        </Tooltip>
      
        <span className="ml-2">{text}</span>
        <InfoTooltipLink
          text={translate(`program_tooltip_${name}`)} 
          className="ml-2"
          />
      </div>
    </Container>
  )
}

const Container = styled.div`
  cursor: pointer;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */

  svg {
    margin-bottom: 0.1rem;
    font-size: 1rem;

    &.blue {
      color: #026af9;
    }

    &.red {
      color: #d64647;
    }

    &.green {
      color: ${({theme}) => theme.palette.success[0]};
    }

    &.white {
      color: ${({theme}) => theme.palette.white[0]};
      border: 1px solid black;
      border-radius: 0.2rem;
    }
  }

  > span {
    font-weight: 600;
  }
`

export default MultiStateCheckbox
